import 'rxjs';
import { mapTo, filter } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { ADD_MODAL, ADD_MODAL_FORCE } from '../actions/addModal';
import { removeModal } from '../actions/removeModal';
import { MODAL_TERMS_AND_CONDITIONS } from '../constants/modalCodes';

export const closeTermsOfServiceModal = (action$) =>
  action$
    .pipe(
      ofType(
        ADD_MODAL_FORCE,
        ADD_MODAL,
      ),
      filter((action) => action.meta.typeId !== MODAL_TERMS_AND_CONDITIONS),
      mapTo((dispatch, getState) => {
        const state = getState();
        const termsModal = state.messageSystem.modals.queue.find(({ typeId }) => typeId === MODAL_TERMS_AND_CONDITIONS);

        if (termsModal && termsModal.id) {
          dispatch(removeModal(termsModal.id));
        }
      }),
    );
